'use client';

import { c as _c } from "react/compiler-runtime";
import { DonationIntervals, PaymentMethods } from 'api-graphql-types/enums';
import { toLowerCase } from 'betterplace-utils';
import { Fieldset, FieldsetProps, Heading, RadioButton, Tooltip } from 'design-system/client';
import { useTranslations } from 'next-intl';
import analytics, { getDonationFormType } from 'product-analytics';
import { useEffect, useRef, useState } from 'react';
import styles from './PaymentMethodSelection.module.css';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import DirectDepositInfo from '@/donationPages/_dependencies/components/formParts/DirectDepositInfo';
import FiscalYearChangeNotice from '@/donationPages/_dependencies/components/formParts/FiscalYearChangeNotice';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function PaymentMethodSelection(t0) {
  const $ = _c(39);
  const {
    className,
    layout: t1
  } = t0;
  const layout = t1 === undefined ? "vertical" : t1;
  const t = useTranslations();
  const {
    paymentMethods,
    recurringPaymentMethods,
    defaultPaymentMethod,
    receiverId,
    receiverType,
    channel,
    showCodonation
  } = useDonationFormConfig();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["interval", "payment_method"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [interval, paymentMethod] = useDonationFormValues(t2);
  const isRecurring = interval !== DonationIntervals.Single;
  const [isTwitterBrowser, setIsTwitterBrowser] = useState(false);
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (typeof navigator === "undefined") {
        return;
      }
      const timeout = setTimeout(() => setIsTwitterBrowser(/Twitter/i.test(navigator.userAgent)), 0);
      return () => clearTimeout(timeout);
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const previousPaymentMethod = useRef(defaultPaymentMethod);
  let t5;
  let t6;
  if ($[3] !== channel || $[4] !== paymentMethod || $[5] !== receiverId || $[6] !== receiverType || $[7] !== showCodonation) {
    t5 = () => {
      if (paymentMethod === previousPaymentMethod.current) {
        return;
      }
      analytics.paymentMethodChanged({
        id: receiverId,
        receiver_type: receiverType,
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        }),
        previous_payment_method: previousPaymentMethod.current,
        new_payment_method: paymentMethod
      });
      previousPaymentMethod.current = paymentMethod;
    };
    t6 = [channel, paymentMethod, receiverId, receiverType, showCodonation];
    $[3] = channel;
    $[4] = paymentMethod;
    $[5] = receiverId;
    $[6] = receiverType;
    $[7] = showCodonation;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== t) {
    t7 = t("nextjs.donate.payment_method.headline");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <Heading level="heading-xs" className={styles.headingMargin}>{t7}</Heading>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== className) {
    t9 = {
      className
    };
    $[14] = className;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isRecurring || $[17] !== isTwitterBrowser || $[18] !== paymentMethods || $[19] !== recurringPaymentMethods || $[20] !== t) {
    let t11;
    if ($[22] !== isRecurring || $[23] !== isTwitterBrowser || $[24] !== recurringPaymentMethods || $[25] !== t) {
      t11 = name => {
        const isBrowserUnsupported = name === PaymentMethods.Paypal && isTwitterBrowser;
        const isRecurringUnsupported = isRecurring && !recurringPaymentMethods.includes(name);
        if (name === PaymentMethods.StripeApplePay || name === PaymentMethods.StripeGooglePay) {
          return null;
        }
        const tooltipContent = isBrowserUnsupported ? t("nextjs.donate.errors.paypal_unsupported_browser") : isRecurringUnsupported ? t("nextjs.donate.recurring_disabled_tooltip") : null;
        const disabled = isBrowserUnsupported || isRecurringUnsupported;
        return <div key={name}><Tooltip content={tooltipContent} inactive={!disabled}><DonationFormField name="payment_method" type="radio" as={RadioButton} value={name} disabled={disabled} classNames={{
              container: styles.radio
            }}>{t(`nextjs.donate.payment_method.labels.${toLowerCase(name)}`)}</DonationFormField></Tooltip></div>;
      };
      $[22] = isRecurring;
      $[23] = isTwitterBrowser;
      $[24] = recurringPaymentMethods;
      $[25] = t;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    t10 = paymentMethods.map(t11);
    $[16] = isRecurring;
    $[17] = isTwitterBrowser;
    $[18] = paymentMethods;
    $[19] = recurringPaymentMethods;
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[27] !== layout || $[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
    t11 = <Fieldset legend={t8} layout={layout} layoutProps={t9} className={styles.fieldset}>{t10}</Fieldset>;
    $[27] = layout;
    $[28] = t10;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  let t13;
  if ($[32] !== paymentMethod) {
    t12 = <DirectDepositInfo paymentMethod={paymentMethod} />;
    t13 = <FiscalYearChangeNotice paymentMethod={paymentMethod} />;
    $[32] = paymentMethod;
    $[33] = t12;
    $[34] = t13;
  } else {
    t12 = $[33];
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t13) {
    t14 = <>{t11}{t12}{t13}</>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
export default PaymentMethodSelection;